@if (!(project$ | async)) {
<div>
  <mat-dialog-content>
    @if (projectLoading$ | async) {
    <div fxLayoutAlign="center center">
      <mat-spinner [diameter]="30"></mat-spinner>
    </div>
    } @if (!(projectLoading$ | async)) {
    <p>
      The link you have followed is for a <strong>private project</strong>. For
      more information contact the project admin.
    </p>
    }
  </mat-dialog-content>
  @if (!(projectLoading$ | async)) {
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>CLOSE</button>
  </mat-dialog-actions>
  }
</div>
} @if (project$ | async; as data) {
<div>
  @if (showBackButton) {
  <button
    class="backbtn"
    (click)="goBack()"
    class="material-icons"
    mat-icon-button
  >
    <mat-icon>arrow_back</mat-icon>
  </button>
  }
  <h2
    style="display: inline-block"
    class="summaryCardProjectTitle"
    mat-dialog-title
  >
    {{ data.name }}
  </h2>
  <mat-dialog-content>
    <mat-horizontal-stepper linear>
      <mat-step label="Project Summary">
        <div>
          <p><b>Description:</b></p>
          <p>{{ data.description }}</p>
          @if (data.protocolLink) {
          <p>
            <b>Protocol: </b>
            <a style="cursor: pointer">{{ data.protocolLink }}</a>
          </p>
          } @if (data.keywords.length != 0) {
          <p><b>Keywords:</b> {{ data.keywords }}</p>
          }
        </div>
        <mat-dialog-actions fxLayoutAlign="end">
          <button mat-button mat-dialog-close>CANCEL</button>
          @if ( (featureToggleService.projectJoinRequest$ | async) &&
          !data.isMember ) {
          <button
            (click)="showButton()"
            mat-raised-button
            color="primary"
            matStepperNext
            type="button"
          >
            REQUEST TO JOIN
          </button>
          } @if ( !(featureToggleService.projectJoinRequest$ | async) &&
          !data.isMember ) {
          <button
            (click)="onRegister(data.id)"
            mat-raised-button
            color="primary"
          >
            JOIN
          </button>
          }
        </mat-dialog-actions>
      </mat-step>

      @if (featureToggleService.projectJoinRequest$ | async) {
      <mat-step>
        <div fxLayout="row">
          <mat-form-field
            fxFlex="100"
            [appearance]="'outline'"
            [formGroup]="comment"
          >
            <mat-label
              >Would you like send any comments to the project admin?</mat-label
            >
            <textarea
              rows="6"
              matInput
              matNativeControl
              formControlName="commentContent"
            ></textarea>
          </mat-form-field>
        </div>
        <mat-dialog-actions fxLayoutAlign="end">
          <button #backButton matStepperPrevious hidden></button>
          <button
            id="summaryCardProjectCancelButton"
            mat-button
            mat-dialog-close
            style="margin-left: 60%"
          >
            CANCEL
          </button>
          <button
            (click)="onRegister(data.id)"
            mat-raised-button
            color="primary"
          >
            SUBMIT
          </button>
        </mat-dialog-actions>
      </mat-step>
      }
    </mat-horizontal-stepper>
  </mat-dialog-content>
</div>
}
